// vuex/store.js
import Vue from "vue";
import Vuex from "vuex";
import { getResources } from "@/api/system";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    resourcesObject: null, // 全局状态
    isLoaded: false, // 加载状态
    productDetails: null, //产品详情
  },
  getters: {
    resourcesObjectValue: (state) => {
      return state.resourcesObject;
    },
    isLoadedValue: (state) => {
      return state.isLoaded;
    },
  },
  mutations: {
    setResourcesObject(state, resources) {
      state.resourcesObject = resources; // 更新全局状态
    },
    setIsLoaded(state, status) {
      state.isLoaded = status;
    },
    SET_PRODUCT_DETAILS(state, data) {
      state.productDetails = data;
    },
  },
  actions: {
    setProductDetails({ commit }, data) {
      commit("SET_PRODUCT_DETAILS", data);
    },
    async fetchResources({ commit }) {
      commit("setIsLoaded", false);

      const response = await getResources(1, 1000);
      const resources = response.rows;

      const processedResources = {};

      for (const resource of resources) {
        if (resource.resourcesType === "image-text") {
          if (resource.resourcesName.match(/[A-Za-z]+/)[0] === "ShowProduct") {
            if (!processedResources.product) {
              processedResources.product = [];
            }
            processedResources.product.push({
              type: resource.resourcesType,
              url: resource.resourcesUrl,
              titleContent: resource.resourcesContent.split(" \\n ")[0],
              textContent: resource.resourcesContent.split(" \\n ")[1],
              herf: resource.resourcesContent.split(" \\n ")[2],
              name: resource.resourcesName.match(/[A-Za-z]+/)[0],
            });
          } else {
            if (!processedResources.imageText) {
              processedResources.imageText = [];
            }
            processedResources.imageText.push({
              type: resource.resourcesType,
              url: resource.resourcesUrl,
              titleContent: resource.resourcesContent.split(" \\n ")[0],
              textContent: resource.resourcesContent.split(" \\n ")[1],
              herf: resource.resourcesContent.split(" \\n ")[2],
              name: resource.resourcesName.match(/[A-Za-z]+/)[0],
            });
            processedResources.imageText.imageTextTotal += 1;
          }
        } else {
          processedResources[resource.resourcesName] = {
            type: resource.resourcesType,
            url: resource.resourcesUrl,
            content: resource.resourcesContent
              ? resource.resourcesContent.replace(/\\n/g, "<br>")
              : resource.resourcesContent,
          };

          // 在创建 carouselImgList 时初始化 image 属性
          if (resource.resourcesName === "carouselImgList") {
            processedResources.carouselImgList = {
              type: resource.resourcesType,
              url: resource.resourcesUrl.split(","),
              name: resource.resourcesName.match(/[A-Za-z]+/)[0],
              image: [], // 初始化 image 属性
            };

            for (
              let i = 0;
              i < processedResources.carouselImgList.url.length;
              i++
            ) {
              processedResources.carouselImgList.image.push({
                url: processedResources.carouselImgList.url[i],
                name: `image${i}`,
              });
            }
          }
        }
      }

      if (
        processedResources.WebOnlineStatus &&
        processedResources.WebOnlineStatus.content === "false"
      ) {
        this.$router.push({ path: "/404" });
      }

      commit("setResourcesObject", processedResources);
      commit("setIsLoaded", true);
    },
  },
});
